module.exports = __webpack_public_path__ + "img/LUB00331.00deafc7.png";